import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom';

const dumpsterOptions = {
    option1: {
        yd: 10,
        ton: 1,
        basePrice: 450,
        // salePrice: 410,
        savings: 25 // called discount on the full estimate
    },
    option2: {
        yd: 15,
        ton: 1.5,

        basePrice: 550,
        // salePrice: 510,
        savings: 25 // called discount on the full estimate

    },
    // option3:{
    //     yd: 15,
    //     ton: 1.5,
    //     basePrice: 495,
    //     salePrice: 440,
    //     savings: 55
    // }

}

//Load inital settings to be 10 yard dumpster
const initialDumpsterOptions = {
    size: dumpsterOptions.option1.yd,
    baseDays: 14,
    price: dumpsterOptions.option1.basePrice,
    threeDayDiscount: 25,
    lateFee: 0, // load page with no fees
    tonnage:dumpsterOptions.option1.ton,
    discount: false,
    numberOfDaysForSalePrice: 3, // Right now
    extraFeePerDay: 25
}

function MiniEstimate() {
    // set state
    const [dumpsterSize, setDumpsterSize] = useState(initialDumpsterOptions.yd);
    const [daysNeeded, setDaysNeeded] = useState(initialDumpsterOptions.baseDays);
    const [price, setPrice] = useState(initialDumpsterOptions.price);
    const [currDiscount, setCurrDiscount] = useState(initialDumpsterOptions.threeDayDiscount);
    const [basePrice, setBasePrice] = useState(initialDumpsterOptions.price);
    const [numDaysFee , setNumDaysFee] = useState(initialDumpsterOptions.lateFee);
    const [tonnage, setTonnage] = useState(initialDumpsterOptions.tonnage);
    const [isDiscount, setIsDiscount] = useState(initialDumpsterOptions.discount);
    
    useEffect( () => {
        updatePrice(daysNeeded);
        
}, [basePrice, daysNeeded]);

// Every time that the daysNeeded state changes, check to see if the days needed is 3 or less,
    // if so, update the set isDiscount to be true
    useEffect(() => {
        if(daysNeeded <= initialDumpsterOptions.numberOfDaysForSalePrice){
            setIsDiscount(true)
        }else{
            setIsDiscount(false)
        }
    }
, [daysNeeded]);

    // Event Handler - invoked when dumpster size changes
    const handleRentalChange = ({target}) =>{
        console.log(target.value)
        const currOption = dumpsterOptions[target.value]; // dynamic
        setDumpsterSize(currOption.yd);
        setCurrDiscount(currOption.savings);
        setBasePrice(currOption.basePrice);
        setTonnage(currOption.ton);
        // updatePrice(daysNeeded);
    }

    // Event Handler - invoked when days needed changes
    const handleDaysChange = ({target}) => {
        setDaysNeeded(target.value);

    }
    const updatePrice = (days) => {
        if(days <= initialDumpsterOptions.numberOfDaysForSalePrice){
            //change price to 3 days special
            setPrice(basePrice - currDiscount);
        }else if( days > initialDumpsterOptions.baseDays){
            //change price to include extra fee of $25 per day
            //set new fee for days
    
            const extraCharge = (days - initialDumpsterOptions.baseDays) * initialDumpsterOptions.extraFeePerDay;
            setNumDaysFee(extraCharge)
            setPrice(basePrice + extraCharge);
        }else{
            //change price to base price
            //change day fees to 0
            setNumDaysFee(0)
            setPrice(basePrice);
        }
    }
  return (
    
    <>
    
    <section className= "estimate">
        <h3>Rental Calculator</h3>
        <div id= "mini-input-container">
            <div className= "mini-input">
                <label htmlFor="mini-dumpster-size">Dumpster Size</label>
                <select id= "mini-dumpster-size"onChange= {handleRentalChange}>
                    <option value="option1">10 Yards ( { dumpsterOptions.option1.ton} ton limit )</option>

                    <option value="option2">15 Yards ( { dumpsterOptions.option2.ton} ton limit )</option>
                    {/* <option value="option3">15 Yards (1.5 ton limit)</option> */}
                </select>
            </div>
            <div className= "mini-input">
                <label htmlFor="mini-days">Days Needed</label>
                <input id= "mini-days" onChange= {handleDaysChange} value= {daysNeeded} type="number" min= "1" max= "30"/>
            </div>
            
        </div>
        <div className= "estimate-breakdown">
            <h3>Size</h3>
            <div className= "estimate-breakdown-section">
                <p>{dumpsterSize} Yard dumpster</p>
                <p>${basePrice}</p>
            </div>

            <h3>Tonnage</h3>
            <div className= "estimate-breakdown-section">
                <p>{tonnage} Ton Limit</p>
                <p>$0</p>
            </div>

            <h3>Days</h3>
            <div className= "estimate-breakdown-section">
                <p>{daysNeeded} Day rental ({daysNeeded - initialDumpsterOptions.baseDays > 0 ? daysNeeded - initialDumpsterOptions.baseDays: 0} extra days.)</p>
                <p>${numDaysFee}</p>
            </div>
            { (isDiscount) && (
            <>
                <h3>Discount</h3>
                <div id = "mini-discount" className= "estimate-breakdown-section">
                    <p>3 Day special for {dumpsterSize} yard dumpster</p>
                    <p>-${currDiscount}</p>
                </div>
            </>)}
        
        
        
        </div>
        <div className= "estimate-output" >
            <p>Total</p>
            <p>${price}.00</p>
        </div>
        <p id= "mini-calc-link">Click <Link to= "/Estimate">here</Link> to check out our extensive calculator.</p>
        <p className="asterisk"><sup>*</sup>Select 3 days or less and get our 3 day special price!</p>
    </section></>
    
  )
}

export default MiniEstimate;